import { Chart } from "~/modules/charts/types";

// // // //

/**
 * FREE_PLAN_CHART_LIMIT
 * The number of charts a user on the FREE plan can save. Paid plans (and
 * superadmins) are unlimited. Enforced server-side in `chartsRouter`; the
 * client mirrors it to surface the upgrade prompt before a save is attempted.
 */
export const FREE_PLAN_CHART_LIMIT = 3;

/**
 * countSavedCharts
 * The charts that count toward a user's free-plan limit: non-official charts
 * they created in their current organization. Mirrors the server-side count
 * (archived charts are already excluded from `charts.list`).
 */
export function countSavedCharts(
    charts: Chart[],
    user: { id: string; organization: { id: string } },
): number {
    return charts.filter(
        (chart) =>
            chart.createdByUserID === user.id &&
            chart.organizationID === user.organization.id &&
            !chart.official,
    ).length;
}
